import { PARTNERS } from "../../data/content";
import { Reveal } from "../motion/Motion";

export default function Partners() {
  const items = [...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section data-testid="partners-section" className="border-y border-brand-primary/10 bg-white py-16">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <p className="mb-10 text-center font-mono text-xs uppercase tracking-[0.25em] text-brand-primary/50">
            Megbízható gyártói rendszerekkel dolgozunk
          </p>
        </Reveal>
        <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
          <div className="flex w-max animate-marquee items-center gap-20 hover:[animation-play-state:paused]">
            {items.map((p, i) => (
              <img
                key={i}
                src={p.logo}
                alt={p.name}
                data-testid={`partner-logo-${i}`}
                className="h-10 w-auto shrink-0 object-contain opacity-50 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 md:h-12"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
